<app-header></app-header>
<main>
    <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" color="#fff" type="ball-newton-cradle"></ngx-spinner>
    <p-toast [life]="3000"></p-toast>
    <router-outlet name='pages' #o="outlet"></router-outlet>
</main>
<app-footer></app-footer>